import $ from 'jquery';

export default class ImageZoom {
  constructor(options) {
    this.$el = $(options.el);
    this.zoomArea = $('.product-image-zoom', this.$el);
    this.$newImage = null;

    this._bindEvents();
  }

  _bindEvents() {
    this.$el.on('prepare-zoom', () => this.prepareZoom());
    this.$el.on('click', (event) => this.toggleZoom(event));
    this.zoomArea.on('mouseout', (event) => this.toggleZoom(event));
    this.zoomArea.on('mousemove', (event) => this.zoomImage(event));
    $('img', this.$el).one('rimg:load', () => this.prepareZoom());
  }

  prepareZoom() {
    const photoAreaWidth = this.$el.width();
    const photoAreaHeight = this.$el.height();

    const newImage = new Image();
    this.$newImage = $(newImage);

    this.$newImage.on('load', () => {
      this.zoomImageWidth = newImage.width;
      this.zoomImageHeight = newImage.height;

      const ratios = [];
      ratios[0] = this.zoomImageWidth / photoAreaWidth;
      ratios[1] = this.zoomImageHeight / photoAreaHeight;

      const ratio = Math.max(...ratios);

      // Only enable the zoom if a certain zooming ratio is met.
      if (ratio < 1.4) {
        this.$el.removeClass('zoom-enabled');
        return;
      }
      this.$el.addClass('zoom-enabled');

      this.zoomArea.css({
        backgroundImage: `url(${newImage.src})`,
      });
    });

    newImage.src = $('img', this.$el).attr('src');
  }

  toggleZoom(e) {
    if (this.$el.hasClass('zoom-enabled')) {
      if (e.type === 'mouseout') {
        this.zoomArea.removeClass('active');
        return;
      }

      if (this.zoomArea.hasClass('active')) {
        this.zoomArea.removeClass('active');
      } else {
        this.zoomArea.addClass('active');
      }

      this.zoomImage(e);
    }
  }

  zoomImage(e) {
    const zoomWidth = this.zoomArea.width();
    const zoomHeight = this.zoomArea.height();

    const bigImageOffset = this.$el.offset();
    const bigImageX = Math.round(bigImageOffset.left);
    const bigImageY = Math.round(bigImageOffset.top);

    const mousePositionX = e.pageX - bigImageX;
    const mousePositionY = e.pageY - bigImageY;

    // Make sure our mouse position is still inside our box.
    if (
      (mousePositionX < zoomWidth)
      && (mousePositionY < zoomHeight)
      && (mousePositionX > 0) && (mousePositionY > 0)
    ) {
      if (this.zoomArea.hasClass('active')) {
        // Figure out how to position the zoomed image.
        let ratioX = Math.round(((mousePositionX / zoomWidth)
                      * this.zoomImageWidth) - (zoomWidth / 2)) * -1;
        let ratioY = Math.round(((mousePositionY / zoomHeight)
                      * this.zoomImageHeight) - (zoomHeight / 2)) * -1;

        if (ratioX > 0) { ratioX = 0; }
        if (ratioY > 0) { ratioY = 0; }

        if (ratioX < -(this.zoomImageWidth - zoomWidth)) {
          ratioX = -(this.zoomImageWidth - zoomWidth);
        }

        if (ratioY < -(this.zoomImageHeight - zoomHeight)) {
          ratioY = -(this.zoomImageHeight - zoomHeight);
        }

        const newBackgroundPosition = `${ratioX}px ${ratioY}px`;

        this.zoomArea.css({
          backgroundPosition: newBackgroundPosition,
        });
      }
    }
  }

  prepareRemove() {
    this.$newImage.off('load');
  }
}
